<template>
  <section>
    <div class="container">
      <b-card class="shadow p-3 mb-5 bg-white rounded m-4">
        <b-row>
          <b-col cols="4">
            <b-link class="text-left h4" to="/dashboard">
              <b-icon
                icon="chevron-left"
                style="width: 25px; height: 25px;"
              ></b-icon>
              Kembali
            </b-link>
          </b-col>
          <b-col cols="4">
            <b-card-title class="text-center h3"
              >{{ updateSubmit ? "Edit" : "Tambah" }} Rekening</b-card-title
            >
          </b-col>
        </b-row>
        <b-card-body>
          <ValidationObserver v-slot="{ handleSubmit }">
            <b-form @submit.prevent="handleSubmit(saveBankAccount)">
              <b-form-group>
                <label>Nama Bank<span class="text-danger"> *</span></label>
                <ValidationProvider
                  name="nama bank"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    v-model="form.bank_id"
                    :options="bankOptions"
                    :reduce="bank => bank.value"
                    label="text"
                    placeholder="Pilih bank..."
                    required
                  ></v-select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>

              <b-form-group>
                <label>Nomor Rekening<span class="text-danger"> *</span></label>
                <ValidationProvider
                  name="nomor rekening"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-input
                    type="text"
                    v-model="form.account_number"
                    required
                    placeholder="Masukan nomor rekening"
                  ></b-form-input>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>

              <b-form-group>
                <label
                  >Nama Pemilik Rekening<span class="text-danger">
                    *</span
                  ></label
                >
                <ValidationProvider
                  name="nama pemilik"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-input
                    type="text"
                    v-model="form.account_name"
                    required
                    placeholder="Masukan nama pemilik rekening"
                  ></b-form-input>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>

              <div v-if="isLoading" class="text-center">
                <b-spinner variant="primary"></b-spinner>
              </div>
              <div v-else>
                <b-button
                  class="mt-4 btn-custom"
                  block
                  type="submit"
                  variant="primary"
                  >{{ updateSubmit ? "Simpan" : "Tambah" }} Rekening</b-button
                >
              </div>
            </b-form>
          </ValidationObserver>
        </b-card-body>
      </b-card>
    </div>

    <!-- Modal konfirmasi -->
    <b-modal size="sm" v-model="confirmBankModal" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Apakah Anda yakin ingin menyimpan data rekening ini?</h3>
      </div>
      <div class="row">
        <div class="col">
          <b-button class="mt-3" block @click="confirmSaveBankAccount"
            >Ya</b-button
          >
        </div>
        <div class="col">
          <b-button class="mt-3" block @click="confirmBankModal = false"
            >Tidak</b-button
          >
        </div>
      </div>
    </b-modal>

    <!-- Modal sukses -->
    <b-modal size="sm" v-model="successModal" hide-footer hide-header>
      <div class="d-block text-center">
        <b-icon
          icon="check-circle"
          animation="throb"
          variant="success"
          style="width: 120px; height: 120px;"
        ></b-icon>
        <h3>{{ modalText }}</h3>
      </div>
      <div class="row">
        <div class="col">
          <b-button class="mt-3" block @click="successConfirm">Tutup</b-button>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import JenisBank from "../../api/jenisbank";
import UserBank from "../../api/userbank";

export default {
  name: "BankAccountForm",
  data() {
    return {
      form: {
        id: null,
        bank_id: null,
        account_number: "",
        account_name: ""
      },
      bankOptions: [],
      confirmBankModal: false,
      successModal: false,
      updateSubmit: false,
      modalText: "",
      currentUser: "",
      isLoading: false
    };
  },
  mounted() {
    this.loadData();
  },
  created() {
    if (this.$store.state.auth.user) {
      this.currentUser = this.$store.state.auth.user;
    }

    if (this.$route.params.id) {
      this.updateSubmit = true;
      this.loadBankAccountData(this.$route.params.id);
    }
  },
  methods: {
    loadData() {
      JenisBank.index()
        .then(res => {
          this.bankOptions = res.data.data.map(bank => ({
            value: bank.id,
            text: bank.name
          }));
        })
        .catch(err => console.error("Error loading bank options:", err));
    },
    loadBankAccountData(id) {
      UserBank.showV3(id)
        .then(res => {
          if (res.data.meta.code === 200) {
            const data = res.data.data;
            this.form = {
              id: data.id,
              bank_id: data.bank_id || (data.bank ? data.bank.id : null),
              account_number: data.account_number,
              account_name: data.account_name
            };
          }
        })
        .catch(err => {
          // fallback ke v1 jika v3 tidak tersedia
          UserBank.show(id)
            .then(res => {
              if (res.data.meta.code === 200) {
                const data = res.data.data;
                this.form = {
                  id: data.id,
                  bank_id: data.bank_id || (data.bank ? data.bank.id : null),
                  account_number: data.account_number,
                  account_name: data.account_name
                };
              }
            })
            .catch(err2 => console.error("Error loading bank account data:", err2));
        });
    },
    saveBankAccount() {
      this.confirmBankModal = true;
    },
    confirmSaveBankAccount() {
      this.confirmBankModal = false;
      if (this.updateSubmit) {
        this.updateBankAccount();
      } else {
        this.addBankAccount();
      }
    },
    addBankAccount() {
      this.isLoading = true;
      this.form.user_id = this.currentUser.info.mitra_id;
      UserBank.store(this.form)
        .then(res => {
          if (res.data.meta.code === 200) {
            this.successModal = true;
            this.modalText = "Rekening berhasil ditambahkan";
          }
        })
        .catch(err => console.error("Error adding bank account:", err))
        .finally(() => {
          this.isLoading = false;
        });
    },
    updateBankAccount() {
      this.isLoading = true;
      const payload = {
        id: this.form.id,
        bank_id: this.form.bank_id,
        account_number: this.form.account_number,
        account_name: this.form.account_name
      };
      UserBank.update(payload)
        .then(res => {
          if (res.data.meta.code === 200) {
            this.successModal = true;
            this.modalText = "Rekening berhasil diperbarui";
          }
        })
        .catch(err => console.error("Error updating bank account:", err))
        .finally(() => {
          this.isLoading = false;
        });
    },
    successConfirm() {
      this.$router.push("/dashboard");
    }
  }
};
</script>
<style scoped>
.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border-radius: 5px;
}
.btn-custom:hover {
  background-color: #274c8f;
  color: #ffffff;
}
.cancel:hover {
  background-color: #fd0000;
  color: #ffffff;
}
.success:hover {
  background-color: #00b300;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/public/dashboard/bank-form.vue